import { render } from "./user_activation.vue?vue&type=template&id=72943b53&scoped=true"
import script from "./user_activation.vue?vue&type=script&lang=js"
export * from "./user_activation.vue?vue&type=script&lang=js"

import "./user_activation.vue?vue&type=style&index=0&id=72943b53&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72943b53"]])

export default __exports__